import styled from 'styled-components';

export const StyledSidebarContent = styled.div`
    [data-active='true'] {
        background-color: var(--color-blue-100) !important;
        color: var(--color-blue-900) !important;
    }

    [data-active='true']:hover {
        background-color: var(--color-blue-100) !important;
        color: var(--color-blue-900) !important;
    }
`;
